// extracted by mini-css-extract-plugin
export default {"skills":"skills_skills__1MD0+","row":"skills_row__qb1jT","description":"skills_description__ow0EV","grid":"skills_grid__EfvGX","card":"skills_card__Glpx+"};